export default __webpack_public_path__ + "static/media/bmw-m5.31fd53a6.jpg";